import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import './Sidebar.css';
import betterlandApp from './betterlandApp.webp';

function Sidebar() {
  const role = localStorage.getItem('role');
  console.log("Sidebar - Rol actual:", role);

  // Estados para los acordeones
  const initialAtrasosOpen = (role && role.toLowerCase() === 'convivencia') ? true : false;
  const [isAtrasosOpen, setIsAtrasosOpen] = useState(initialAtrasosOpen);
  const [isFluidezOpen, setIsFluidezOpen] = useState(false);
  const [isAsistenciaOpen, setIsAsistenciaOpen] = useState(false); // Acordeón para Asistencia

  const toggleAtrasos = () => {
    setIsAtrasosOpen(!isAtrasosOpen);
  };

  const toggleFluidez = () => {
    setIsFluidezOpen(!isFluidezOpen);
  };

  const toggleAsistencia = () => {
    setIsAsistenciaOpen(!isAsistenciaOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    console.log("Token y rol eliminados. Rol actual:", localStorage.getItem('role'));
    window.location.href = '/login';
  };

  // Interceptor para redirigir al login cuando el token expire
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  // Rol Convivencia: Solo muestra el menú de Atrasos
  if (role && role.toLowerCase() === 'convivencia') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <div className="accordion">
            <button className="accordion-button white-text" onClick={toggleAtrasos}>
              Atrasos
            </button>
            {isAtrasosOpen && (
              <div className="accordion-content">
                <NavLink 
                  to="/Atrasos" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Atrasos Entrada
                </NavLink>
                <NavLink 
                  to="/AtrasosAula" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Atrasos Aula
                </NavLink>
              </div>
            )}
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // Rol Profesor Jefe: Muestra Estadísticas Individuales, Atrasos y Programa de Fluidez
  if (role === 'Profesor Jefe') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <NavLink 
            to="/matricula" 
            className={({ isActive }) => isActive ? "active-link" : ""}
          >
            Estadísticas Individuales
          </NavLink>
          <div className="accordion">
            <button className="accordion-button white-text" onClick={toggleAtrasos}>
              Atrasos
            </button>
            {isAtrasosOpen && (
              <div className="accordion-content">
                <NavLink 
                  to="/Atrasos" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Atrasos Entrada
                </NavLink>
                <NavLink 
                  to="/AtrasosAula" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Atrasos Aula
                </NavLink>
              </div>
            )}
          </div>
          <div className="accordion">
            <button className="accordion-button white-text" onClick={toggleFluidez}>
              Programa de Fluidez
            </button>
            {isFluidezOpen && (
              <div className="accordion-content">
                <NavLink 
                  to="/resumen-fluidez" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Resumen Fluidez
                </NavLink>
              </div>
            )}
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // Rol Fluidez: Solo muestra el menú de Programa de Fluidez
  if (role === 'Fluidez') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <div className="accordion">
            <button className="accordion-button white-text" onClick={toggleFluidez}>
              Programa de Fluidez
            </button>
            {isFluidezOpen && (
              <div className="accordion-content">
                <NavLink 
                  to="/fluidez-lectora" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Fluidez Lectora
                </NavLink>
                <NavLink 
                  to="/fluidez-matematicas" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Fluidez Matemáticas
                </NavLink>
                <NavLink 
                  to="/resumen-fluidez" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Resumen Fluidez
                </NavLink>
              </div>
            )}
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // Rol Estudiante: menú personalizado
  if (role && role === 'Estudiante') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <NavLink to="/student/profile" className={({ isActive }) => isActive ? "active-link" : ""}>
            Mi Perfil
          </NavLink>
          <NavLink to="/student/electivos" className={({ isActive }) => isActive ? "active-link" : ""}>
            Toma de Electivos
          </NavLink>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // Admin Electivos
  if (role === 'Electivos Admin') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <NavLink to="/electivos-admin" className={({isActive})=>isActive?'active-link':''}>
            Gestión de Usuarios
          </NavLink>
          <NavLink to="/paneldecontrol-admin" className={({isActive})=>isActive?'active-link':''}>
            Panel de Control
          </NavLink>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // 👇 Rol Funcionario: AQUÍ SÍ SE MANTIENE EL ACCESO A SEGURIDAD
  if (role === 'Funcionario') {
    return (
      <div className="sidebar">
        <img src={betterlandApp} alt="Betterland App" className="header-image" />
        <nav>
          <NavLink to="/mi-perfil" className={({ isActive }) => isActive ? "active-link" : ""}>
            Mi Perfil
          </NavLink>
          <NavLink to="/seguridad" className={({ isActive }) => isActive ? "active-link" : ""}>
            Seguridad
          </NavLink>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </nav>
      </div>
    );
  }

  // Para Admin, Data Manager y Viewer globales (Menu por defecto)
  return (
    <div className="sidebar">
      <img src={betterlandApp} alt="Betterland App" className="header-image" />
      <nav>
        <div className="accordion">
          <button className="accordion-button white-text" onClick={toggleAsistencia}>
            Asistencia
          </button>
          {isAsistenciaOpen && (
            <div className="accordion-content">
              <NavLink 
                to="/dashboard" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Dashboard
              </NavLink>
              <NavLink 
                to="/estadisticas" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Estadísticas Diarias
              </NavLink>
              <NavLink 
                to="/matricula" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Estadísticas Individuales
              </NavLink>
              {(role === 'Admin' || role === 'Data Manager' || role === 'Viewer') && (
                <NavLink 
                  to="/AusentismoCronico" 
                  className={({ isActive }) => isActive ? "active-link" : ""}
                >
                  Ausentismo Crónico
                </NavLink>
              )}
            </div>
          )}
        </div>
        <div className="accordion">
          <button className="accordion-button white-text" onClick={toggleAtrasos}>
            Atrasos
          </button>
          {isAtrasosOpen && (
            <div className="accordion-content">
              <NavLink 
                to="/Atrasos" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Atrasos Entrada
              </NavLink>
              <NavLink 
                to="/AtrasosAula" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Atrasos de Aula
              </NavLink>
            </div>
          )}
        </div>
        <div className="accordion">
          <button className="accordion-button white-text" onClick={toggleFluidez}>
            Programa de Fluidez
          </button>
          {isFluidezOpen && (
            <div className="accordion-content">
              <NavLink 
                to="/fluidez-lectora" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Fluidez Lectora
              </NavLink>
              <NavLink 
                to="/fluidez-matematicas" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Fluidez Matemáticas
              </NavLink>
              <NavLink 
                to="/resumen-fluidez" 
                className={({ isActive }) => isActive ? "active-link" : ""}
              >
                Resumen Fluidez
              </NavLink>
            </div>
          )}
        </div>
        {(role === 'Data Manager' || role === 'Admin') && (
          <NavLink 
            to="/carga-asistencia" 
            className={({ isActive }) => isActive ? "active-link" : ""}
          >
            Carga Asistencia
          </NavLink>
        )}
        {role === 'Admin' && (
          <NavLink 
            to="/gestion-usuarios" 
            className={({ isActive }) => isActive ? "active-link" : ""}
          >
            Gestión de Usuarios
          </NavLink>
        )}

        <button className="logout-button" onClick={handleLogout}>
          Cerrar Sesión
        </button>
      </nav>
    </div>
  );
}

export default Sidebar;